module.exports = __webpack_public_path__ + "img/tree.96b7a01f.png";